import { Spin } from "antd";
import linkIcon from "../../assets/icons/link-icon.png";
import EmptyScreen from "../empty-screen/EmptyScreen";
import emptyScreenIcon from "../../assets/images/EmptyScreen.png";
import CurrencyFlag from "../currency-flag/CurrencyFlag";
import { useMoneyRequests } from "../../data/live";
import { formatCurrencyAmount } from "../../utils/currencyMeta";

/**
 * The customer's outstanding payment requests.
 *
 * This screen used to render three hardcoded rows, "100 AUD" and "My Family"
 * twice, all "Created 7 February", to every user, whoever they were. A money
 * app must never show someone payment requests that do not exist: they read as
 * the customer's own, and there is no way to tell them apart from real ones.
 * The API and the useMoneyRequests hook already existed; nothing was calling
 * them.
 */
const formatCreated = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `Created ${d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
  })}`;
};

const RequestMoneyActive = () => {
  const { items, loading } = useMoneyRequests();

  // Only requests still awaiting payment belong on an "Active" tab.
  const activeRequests = items.filter(
    (request) => (request.status || "PENDING") === "PENDING"
  );

  if (loading) {
    return (
      <div className="border rounded-3 p-5 mt-3 d-flex justify-content-center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="border rounded-3 p-3 mt-3">
      <div
        className={`border rounded-3 ${
          activeRequests.length > 0 ? "overflow-auto" : ""
        }`}
      >
        {activeRequests.length === 0 ? (
          <EmptyScreen
            icon={emptyScreenIcon}
            heading={"No Transactions"}
            message={"You're not waiting on any payments right now"}
          />
        ) : (
          <div className="d-flex flex-column">
            {activeRequests.map((request) => (
              <div
                key={request.id}
                className="d-flex justify-content-between align-items-center cursor-pointer hover-temp px-4 py-3"
              >
                <div className="d-flex gap-2 align-items-center">
                  <CurrencyFlag currency={request.currency} size={34} />
                  <div className="d-flex flex-column">
                    <span className="fs14px fw-semibold">
                      {formatCurrencyAmount(request.amount, request.currency)}{" "}
                      {request.currency}
                    </span>
                    <span className="fs12px" style={{ color: "#7D7D7D" }}>
                      {/* The note is what the customer wrote when asking, so it
                          identifies the request better than the date alone. */}
                      {[request.note, formatCreated(request.createdAt)]
                        .filter(Boolean)
                        .join(" · ")}
                    </span>
                  </div>
                </div>

                <div>
                  <img src={linkIcon} alt="link" width={20} height={20} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestMoneyActive;
